<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户ID">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                <GridSelectU title="选择用户" style="width: 200px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
              </el-form-item>
              <el-form-item label="工单主题">
                  <el-input  style="width: 200px;" v-model="queryForm.subject" placeholder='请输入工单主题'></el-input>
              </el-form-item>
              <el-form-item label="工单编号">
                  <el-input  style="width: 200px;" v-model="queryForm.number" placeholder='请输入工单编号'></el-input>
              </el-form-item>
              <el-form-item label="工单状态">
                  <!-- <el-input  style="width: 200px;" v-model="queryForm.status"></el-input> -->
                  <el-select  style="width: 200px;" v-model="queryForm.status" placeholder='请选择工单状态'>
                    <el-option
                      v-for="item in workOrderEnumList"
                      :key="item.value"
                      :label="item.value"
                      :value="item.key"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getCmsWorkorderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addCmsWorkorder"
        >新建</el-button> -->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editCmsWorkorder(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteCmsWorkorder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportCmsWorkorderList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshCmsWorkorderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="cmsWorkorderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="用户"
        width="180"
      >
	  <template slot-scope="scope">
	    <div v-if="scope.row.user">
            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
        </div>
        <div v-else>--</div>
	  </template>
	  </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="subject"
        label="工单主题"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="number"
        label="工单编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="工单状态"
        width="180"
      >
        <template slot-scope='scope'>
            <div>{{computeWorkOrder(scope.row.status)}}</div>
        </template>
      </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="createTime"
            label="创建时间"
            width="180"
        > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="workorderList(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">回复</span>
              </div>
<!--            <div @click="checkCmsWorkorder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editCmsWorkorder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteCmsWorkorder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="cmsWorkorderStates[cmsWorkorderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="cmsWorkorder"
          ref="cmsWorkorderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户ID"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="cmsWorkorder.userId"
              :disabled="cmsWorkorderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工单主题"
            prop="subject"
          >
            <el-input
              size="small"
              v-model="cmsWorkorder.subject"
              :disabled="cmsWorkorderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工单编号"
            prop="number"
          >
            <el-input
              size="small"
              v-model="cmsWorkorder.number"
              :disabled="cmsWorkorderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="工单状态"
            prop="status"
          >
            <el-input
              size="small"
              v-model="cmsWorkorder.status"
              :disabled="cmsWorkorderState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="cmsWorkorderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

    <!--工单-->
      <el-drawer
          title="工单处理"
          :with-header="false"
          :visible.sync="workOrderDialogVisible"
          direction="rtl"
          :before-close="closeWorkorderList">
          <div class="afterRecord">
              <div class="ReturnProcess">
                  <div>工单编号：{{workOrderData.number}}</div>
                  <div>创建时间：{{workOrderData.createTime}}</div>
                  <div>工单主题：{{workOrderData.subject}}</div>
              </div>

              <div class="ReturnProcess" v-for="(item,index) in workOrderListData" :key="item.id">
                  <div class="drawer-header">
                      <div class="image-header">
                        <img v-if="item.isMine" :src="userHeader">
                          <img v-else :src="sysHeader">
                      </div>
                      <div class="detail">
                          <strong v-if="item.isMine">用户消息</strong>
                          <strong v-else>回复消息</strong>
                          <span>{{item.createTime}}</span>
                      </div>
                  </div>
                  <div class="content">{{item.content}}</div>
                  <div v-if="item.pics != ''">
                      <el-image
                          v-for="(it,index) in item.pics.split('|')"
                          @click='updateSrcList(item.pics)'
                          style="width: 80px; height: 80px; margin-right: 5px;"
                          :src="it"
                          :preview-src-list="srcList"
                      > </el-image>
                  </div>
              </div>
          </div>
          <div style="width: 100%;height: 60px"></div>
          <div class="btn-box">
              <el-button type="primary" @click="replyWorkOrder">回复</el-button>
              <el-button type="primary" @click="endWorkOrder">完结</el-button>
          </div>
      </el-drawer>
    <!--回复窗口-->
      <el-dialog
          title="回复工单"
          :visible.sync="replyWorkOrderShowDialog"
          width="60%"
          @close="replyWorkOrdercloseDialog"
      >
          <el-input :autosize='{minRows:8,}' type="textarea" v-model="reply.replyContent"></el-input>
          <div style='margin-top: 10px'>
              <el-upload
                  :headers="header"
                  class="uploadAlbum"
                  :action="action"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeAvatarUpload"
                  list-type="picture"
                  accept="jpg,jpeg,png,JPG,JPEG,PNG"
                  :limit="10"
              >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
              </el-upload>
          </div>
          <div style='margin-top: 10px;display: flex;flex-direction: row;justify-content: right'>
              <el-button type="primary" @click="replyWorkOrderData">确认</el-button>
              <el-button @click="replyWorkOrdercloseDialog">取消</el-button>
          </div>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, upload, deleteFun } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH } from '@/utils/constant.js';
import { USER, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetCmsWorkorderList();
                    this.getCmsWorkorderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetCmsWorkorderList();
                    this.getCmsWorkorderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                workOrderEnumList: [],
                workOrderDialogVisible: false,
                workOrderListData: [],
                workOrderData: {},
                srcList:[],
                sysHeader: '',
                userHeader: '',
                USER_code: USER,
                USER_search: USER_SEARCH,
                replyWorkOrderShowDialog: false,
                reply:{
                    replyContent: '',
                    productPic: [],
                    woId:'',
                },
                fileList:[],
                header: {
                    token: localStorage.getItem('token')
                },
                temporaryList: [],
                action: UPLOAD_API + UPLOAD_PATH,
                albumList: '',

                queryForm:{
                     userId: '', //用户ID
                     subject: '', //工单主题
                     number: '', //工单编号
                     status: '', //工单状态
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                cmsWorkorderState: 'add',
                cmsWorkorderStates: {
                    add: '新建工单',
                    check: '查看工单',
                    edit: '修改工单'
                },

                multipleSelection: [],
                cmsWorkorderList: [],
                cmsWorkorder: {
                    userId: '', //用户ID
                    subject: '', //工单主题
                    number: '', //工单编号
                    status: '', //工单状态
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    subject: [{ required: true, message: '工单主题不能为空', trigger: 'blur' }],
                    number: [{ required: true, message: '工单编号不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '工单状态不能为空', trigger: 'blur' }]
                }
            };
        },
        created() {
            this.getCmsWorkorderList();
            this.getWorkOrderEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetCmsWorkorderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.cmsWorkorderList = [];
            },
            // 搜索用户
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            resetDialog() {
                this.cmsWorkorderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      subject: '', //工单主题
                      number: '', //工单编号
                      status: '', //工单状态
                };
                this.getCmsWorkorderList();
            },
            closeDialog() {
                this.showDialog = false
                this.cmsWorkorder = {
                      userId: '', //用户ID
                      subject: '', //工单主题
                      number: '', //工单编号
                      status: '', //工单状态
                };
            },
            submitForm() {
                if (this.cmsWorkorderState == 'add') {
                    this.$refs.cmsWorkorderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/cms/workorder/add`,{ ...this.cmsWorkorder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetCmsWorkorderList();
                                    this.resetDialog();
                                    this.getCmsWorkorderList();
                                }
                            });
                        }
                    });
                } else if (this.cmsWorkorderState == 'edit') {
                    this.$refs.cmsWorkorderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/cms/workorder/edit`,{ ...this.cmsWorkorder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetCmsWorkorderList();
                                    this.resetDialog();
                                    this.getCmsWorkorderList();
                                }
                            });
                        }
                    });
                }
            },
            addCmsWorkorder() {
                this.showDialog = true;
                this.cmsWorkorderState = 'add';
            },
            checkCmsWorkorder(cmsWorkorderId) {
                console.log(cmsWorkorderId);
                this.currentCmsWorkorderId = cmsWorkorderId;

                this.getCmsWorkorderById();
                this.showDialog = true;
                this.cmsWorkorderState = 'check';
            },
            editCmsWorkorder(cmsWorkorderId) {
                console.log('cmsWorkorder', cmsWorkorderId);
                if (cmsWorkorderId) {
                    this.currentCmsWorkorderId = cmsWorkorderId;
                    this.getCmsWorkorderById();
                } else {
                    this.cmsWorkorder = { ...this.cmsWorkorder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.cmsWorkorderState = 'edit';
            },
            deleteCmsWorkorder(cmsWorkorderId) {
                let ids = '';
                if (cmsWorkorderId) {
                    ids = cmsWorkorderId;
                } else {
                    ids = this.multipleSelection.map((cmsWorkorder) => cmsWorkorder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/cms/workorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsWorkorderList();
                                this.getCmsWorkorderList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshCmsWorkorderList() {
                this.resetCmsWorkorderList();
                this.getCmsWorkorderList();
            },
            getCmsWorkorderList(query = {}) {
                this.loading = true;
                get(`/cms/workorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.cmsWorkorderList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getCmsWorkorderById() {
                get(`/cms/workorder/get`,{ id: this.currentCmsWorkorderId }).then((res) =>{
                    if(res.success){
                      this.cmsWorkorder = { ...this.cmsWorkorder, ...res.cmsWorkorder };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportCmsWorkorderList() {
                //this.btnLoading = true;
                exprotExcel(`/cms/workorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/cms/workorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/cms/workorder/importData`,formData);
              this.refreshCmsWorkorderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getCmsWorkorderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getCmsWorkorderList();
            },
            updateSrcList(src){
                this.srcList = src.split("|")
            },

            //获取工单状态枚举
            getWorkOrderEnum(){
                get('/mpp/utils/getEnum',{
                    enumType: 'workorder_status',
                }).then((res)=>{
                    if(res.success){
                        this.workOrderEnumList = res.enumList
                    }
                })
            },

            computeWorkOrder(type){
                for (let i = 0; i < this.workOrderEnumList.length; i++) {
                    if(this.workOrderEnumList[i].key == type){
                        return this.workOrderEnumList[i].value
                    }
                }
            },

            workorderList(id){
                this.workOrderDialogVisible = true
                this.getWorkOrderList(id)
                this.reply.woId = id
            },

            closeWorkorderList(){
                this.workOrderDialogVisible = false
                this.reply.woId = ''
                this.workOrderListData = []
                this.workOrderData = []
            },

            getWorkOrderList(id){
                get('/cms/workorder/get',{id}).then((res)=>{
                    if(res.success){
                        this.workOrderListData = res.list
                        this.workOrderData = res.workorder
                        this.userHeader = res.userHeader
                        this.sysHeader = res.sysHeader
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                    }
                })
            },
            replyWorkOrder(){
                this.replyWorkOrderShowDialog = true
            },

            replyWorkOrdercloseDialog(){
                this.replyWorkOrderShowDialog = false
                this.reply.replyContent = ''
                this.reply.productPic = []
                this.fileList = []
                this.temporaryList = []
                this.albumList = ''
            },

            //上传成功
            handleSuccess(response, file, fileList) {
                console.log(response);
                console.log(file);
                console.log(fileList);
                this.temporaryList.push(file.response.url);
                console.log(this.temporaryList);
                this.albumList = this.temporaryList.join('|');
                console.log(this.albumList);
            },

            handleRemove(file, fileList) {
                console.log(file);
                console.log(fileList);
                for (let i = 0; i < this.temporaryList.length; i++) {
                    if (file.response.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                }
                this.albumList = this.temporaryList.join('|');

                console.log(this.temporaryList);
            },

            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 50MB!');
                }
                return isLt2M;
            },

            replyWorkOrderData(){
                post('/cms/workorderitem/add',{
                    woId: this.reply.woId,
                    content: this.reply.replyContent,
                    pics: this.albumList
                }).then((res)=>{
                    if(res.success){
                        this.reply.replyContent = ''
                        this.reply.productPic = []
                        this.fileList = []
                        this.temporaryList = []
                        this.albumList = ''
                        this.workorderList(this.reply.woId)
                        this.replyWorkOrdercloseDialog();
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
            },

            endWorkOrder(){
                get('/cms/workorder/finish',{
                    id:this.reply.woId
                }).then((res)=>{
                    if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: 2000
                        });
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
            },

            ///上传视频
            uploadAvatar(params) {
                const file = params.file;
                console.log(file);
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.attributeWholeList.productVideo = res.url;
                        console.log(this.attributeWholeList.productVideo);
                    }
                });
            },
        }

};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.afterRecord {
    padding: 20px;
    overflow: auto;
    font-size: 12px;
    word-wrap:break-word;
}

.ReturnProcess {
    background-color: #f6f6f6;
    padding: 10px 10px;
    margin: 10px auto;
    border-radius: 4px;

    .drawer-header{
        width: 100%;
        display: flex;
        flex-direction: row;

        .image-header{
            width: 40px;
            height: 40px;
            border-radius: 20px;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
            }
        }

        .detail{
            margin-left: 10px;
            display: flex;
            flex-direction: column;
        }
    }
    .content{
        padding: 0;
        margin: 15px 0;
        overflow-y:hidden;
    }
}

.btn-box{
    position: absolute;
    padding: 10px;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
</style>
